import React, { Component } from "react";
import { Divider, Typography, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Layout, Menu } from "antd5";

const { Text } = Typography;
const { Sider, Content } = Layout;

// Compara sin distinguir mayúsculas ni acentos, igual que BuscadorMenuInput.
const normalizar = (str) =>
    String(str || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "");


const construirCoincidencia = (termino) => {
    if (!termino) return () => true;
    const escapado = termino.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const re = new RegExp("\\b" + escapado);
    return (texto) => re.test(normalizar(texto));
};

if (typeof document !== "undefined") {
    const styleId = "sidebar-menu-layout-style";
    if (!document.getElementById(styleId)) {
        const styleEl = document.createElement("style");
        styleEl.id = styleId;
        styleEl.textContent = `
            .sidebar-menu-layout__menu.ant-menu-inline {
                border-inline-end: none !important;
            }
            .sidebar-menu-layout__menu .ant-menu-item {
                border-radius: 0 !important;
                margin-inline: 0 !important;
                width: 100% !important;
                border-left: 3px solid transparent;
                transition: border-left-color 0.2s, background 0.2s, color 0.2s;
            }
            .sidebar-menu-layout__menu .ant-menu-item:hover {
                background-color: #f0fcfd !important;
                border-left-color: #00BFD6 !important;
            }
            .sidebar-menu-layout__menu .ant-menu-item.ant-menu-item-selected {
                background-color: #f0fcfd !important;
                border-left: 3px solid #00BFD6 !important;
                color: #00BFD6 !important;
                font-weight: 600;
            }
            .sidebar-menu-layout__menu .ant-menu-item {
                height: auto !important;
                min-height: 40px !important;
                padding-block: 8px !important;
            }
            .sidebar-menu-layout__menu .ant-menu-title-content {
                white-space: normal !important;
                word-break: break-word !important;
                line-height: 1.3 !important;
                overflow: visible !important;
                text-overflow: unset !important;
            }

            /* ---- Segundo nivel: secciones con subsecciones ---- */

            /* El renglón del módulo padre se comporta igual que un item normal */
            .sidebar-menu-layout__menu .ant-menu-submenu-title {
                border-radius: 0 !important;
                margin-inline: 0 !important;
                width: 100% !important;
                border-left: 3px solid transparent;
                height: auto !important;
                min-height: 40px !important;
                padding-block: 8px !important;
                transition: border-left-color 0.2s, background 0.2s, color 0.2s;
            }
            .sidebar-menu-layout__menu .ant-menu-submenu-title:hover {
                background-color: #f0fcfd !important;
                border-left-color: #00BFD6 !important;
            }
            /* Módulo con subsección activa: se marca aunque esté colapsado */
            .sidebar-menu-layout__menu .ant-menu-submenu-selected > .ant-menu-submenu-title {
                color: #00BFD6 !important;
                font-weight: 600;
            }
            /* Módulo mostrando su portada: se marca como item seleccionado */
            .sidebar-menu-layout__menu .sidebar-menu-layout__modulo--activo > .ant-menu-submenu-title {
                background-color: #f0fcfd !important;
                border-left: 3px solid #00BFD6 !important;
                color: #00BFD6 !important;
                font-weight: 600;
            }
            .sidebar-menu-layout__menu .ant-menu-sub.ant-menu-inline {
                background: transparent !important;
            }
            /* Subsecciones: se distinguen por la sangría, no por el tamaño de letra */
            .sidebar-menu-layout__menu .ant-menu-sub .ant-menu-item {
                font-size: 14px;
                min-height: 34px !important;
                padding-block: 6px !important;
                padding-inline-start: 34px !important;
            }

            /* ---- Neutraliza el azul de antd: todo en celeste BIWO ---- */

            /* En hover antd usa \`itemHoverColor\` (gris); aquí va el celeste */
            .sidebar-menu-layout__menu .ant-menu-item:not(.ant-menu-item-selected):hover,
            .sidebar-menu-layout__menu .ant-menu-submenu-title:hover {
                color: #00BFD6 !important;
                background-color: #f0fcfd !important;
            }

            /* Al mantener el click antd usa \`itemActiveBg\` (#e6f4ff): el destello azul */
            .sidebar-menu-layout__menu .ant-menu-item:not(.ant-menu-item-selected):active,
            .sidebar-menu-layout__menu .ant-menu-submenu-title:active {
                color: #00BFD6 !important;
                background-color: #dcf7fa !important;
            }

            /* El foco por teclado usa \`colorPrimaryBorder\` (azul claro) */
            .sidebar-menu-layout__menu .ant-menu-item:focus-visible,
            .sidebar-menu-layout__menu .ant-menu-submenu-title:focus-visible {
                outline: 2px solid #00BFD6 !important;
                outline-offset: -2px !important;
                box-shadow: none !important;
            }

            /* Iconos y flecha siguen el color del texto, no el azul del tema */
            .sidebar-menu-layout__menu .ant-menu-item .anticon,
            .sidebar-menu-layout__menu .ant-menu-submenu-title .anticon,
            .sidebar-menu-layout__menu .ant-menu-submenu-arrow,
            .sidebar-menu-layout__menu .ant-menu-submenu-arrow::before,
            .sidebar-menu-layout__menu .ant-menu-submenu-arrow::after {
                color: inherit !important;
            }
        `;
        document.head.appendChild(styleEl);
    }
}

class SidebarMenu extends Component {
    state = {
        selectedKey: null,
        selectedSubKey: null,
        openKeys: [],
        search: "",
        isMobile: typeof window !== "undefined" ? window.innerWidth < 768 : false,
    };

    componentDidMount() {
        const { menuItems = [], defaultSelected } = this.props;
        const initialKey =
            defaultSelected ||
            (menuItems.length > 0 ? menuItems[0].key : null);

        const seleccion = this.resolveSelection(initialKey);

        this.setState({
            ...seleccion,
            // Si arranca en un módulo con subsecciones, queda abierto
            openKeys: this.getSubsections(seleccion.selectedKey)
                ? [seleccion.selectedKey]
                : [],
        });

        this._handleResize = () =>
            this.setState({ isMobile: window.innerWidth < 768 });
        window.addEventListener("resize", this._handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this._handleResize);
    }

    // Subsecciones declaradas para una sección, o null si no tiene.
    getSubsections(sectionKey) {
        const { subsections = {} } = this.props;
        const subs = subsections[sectionKey];
        return Array.isArray(subs) && subs.length > 0 ? subs : null;
    }

    resolveSelection(rawKey) {
        if (!rawKey) return { selectedKey: null, selectedSubKey: null };

        const [sectionKey, subKey] = String(rawKey).split("/");
        const subs = this.getSubsections(sectionKey);

        if (!subs) return { selectedKey: sectionKey, selectedSubKey: null };

        const sub = subs.find((s) => s.key === subKey);
        return { selectedKey: sectionKey, selectedSubKey: sub ? sub.key : null };
    }

    terminosDe(key) {
        const { searchTerms } = this.props;
        if (!searchTerms) return "";
        if (!this._terminos) {
            this._terminos =
                typeof searchTerms === "function" ? searchTerms() : searchTerms;
        }
        return (this._terminos && this._terminos[key]) || "";
    }

    menuFiltrado() {
        const { menuItems = [] } = this.props;
        const { selectedKey, selectedSubKey } = this.state;
        const termino = normalizar(this.state.search.trim());
        const coincideTexto = construirCoincidencia(termino);

        const items = [];
        const abiertos = [];

        for (const item of menuItems) {
            if (!item) continue;

            // Separadores y items con children propios: se ocultan al buscar
            if (!item.key || item.children) {
                if (!termino) items.push(item);
                continue;
            }

            const nombreCoincide = !termino || coincideTexto(item.label);
            const portadaCoincide = !!termino && coincideTexto(this.terminosDe(item.key));

            const subs = this.getSubsections(item.key);

            if (!subs) {
                if (nombreCoincide || portadaCoincide) items.push(item);
                continue;
            }

            // El icono es opcional: destaca una pantalla que el usuario podría
            // buscar en otro lado.
            const todos = subs.map((sub) => ({
                key: `${item.key}/${sub.key}`,
                label: sub.navLabel || sub.label || sub.key,
                ...(sub.icon ? { icon: sub.icon } : {}),
                _buscable: `${sub.label || ""} ${sub.navLabel || ""} ${sub.key}`,
            }));

            const hijos = nombreCoincide
                ? todos
                : todos.filter(
                      (h) => coincideTexto(h._buscable) || coincideTexto(this.terminosDe(h.key))
                  );

            if (termino && !nombreCoincide && !portadaCoincide && hijos.length === 0) continue;

            if (termino && hijos.length > 0) abiertos.push(item.key);

            const moduloActivo = selectedKey === item.key && !selectedSubKey;

            items.push({
                ...item,
                className: moduloActivo ? "sidebar-menu-layout__modulo--activo" : undefined,
                onTitleClick: ({ key }) => this.setState(this.resolveSelection(key)),
                children: (hijos.length ? hijos : todos).map(({ _buscable, ...h }) => h),
            });
        }

        return { items, abiertos, buscando: !!termino };
    }

    render() {
        const { selectedKey, selectedSubKey, openKeys, isMobile } = this.state;
        const {
            sectionTitles = {},
            renderContent,
            headerLabel = "Módulos",
            siderWidth = 185,
            menuMaxHeight = "calc(100vh - 220px)",
            minHeight = 520,
            showDividers = false,
            dividerType = "vertical",
            dividerStyle = {},
            footer,
            contentStyle = {},
            siderStyle = {},
            layoutStyle = {},
            searchable = false,
            searchPlaceholder,
        } = this.props;

        const { items, abiertos, buscando } = this.menuFiltrado();

        const sectionTitle = selectedKey ? sectionTitles[selectedKey] || selectedKey : "";

        const subs = selectedKey ? this.getSubsections(selectedKey) : null;
        const activeSub =
            subs && selectedSubKey ? subs.find((s) => s.key === selectedSubKey) : null;

        // La llave del menú es compuesta ("ventas/pedidos") cuando hay subsección
        const menuSelectedKey = selectedSubKey
            ? `${selectedKey}/${selectedSubKey}`
            : selectedKey;

        return (
            <Layout
                style={{
                    background: "#fff",
                    border: "1px solid #f0f0f0",
                    borderRadius: 8,
                    overflow: "hidden",
                    minHeight,
                    ...layoutStyle,
                }}
            >
                {/*  Sidebar */}
                <Sider
                    breakpoint="md"
                    collapsedWidth={0}
                    theme="light"
                    width={siderWidth}
                    style={{
                        background: "#fff",
                        borderRight: "none",
                        boxShadow: "2px 0 8px rgba(0, 0, 0, 0.08)",
                        zIndex: isMobile ? 2 : "auto",
                        marginTop: isMobile ? -49 : 0,
                        ...siderStyle,
                    }}
                >
                    {/* Header gris con etiqueta */}
                    <div
                        style={{
                            padding: "16px 16px 8px",
                            fontSize: 10,
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "0.6px",
                            background: "#f5f5f5",
                            borderBottom: "1px solid #efefef",
                            color: "#8c8c8c",
                        }}
                    >
                        {headerLabel}
                    </div>

                    {searchable && (
                        <div style={{ padding: "10px 12px 6px" }}>
                            <Input
                                allowClear
                                size="small"
                                prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                                placeholder={searchPlaceholder || "Buscar..."}
                                value={this.state.search}
                                onChange={(e) => this.setState({ search: e.target.value })}
                                style={{ borderRadius: 6 }}
                            />
                        </div>
                    )}

                    <div style={{ paddingTop: 8, overflowY: "auto", maxHeight: menuMaxHeight }}>
                        {buscando && items.length === 0 ? (
                            <div style={{ padding: "12px 16px", fontSize: 12.5, color: "#a8a8a8", lineHeight: 1.5 }}>
                                Nada coincide con “{this.state.search.trim()}”.
                            </div>
                        ) : (
                            <Menu
                                className="sidebar-menu-layout__menu"
                                mode="inline"
                                selectedKeys={menuSelectedKey ? [menuSelectedKey] : []}
                                openKeys={buscando ? abiertos : openKeys}
                                onOpenChange={(keys) =>
                                    buscando ? undefined : this.setState({ openKeys: keys.slice(-1) })
                                }
                                items={items}
                                onClick={({ key }) => this.setState(this.resolveSelection(key))}
                                style={{ background: "transparent" }}
                            />
                        )}
                    </div>
                </Sider>

                {/* Divider opcional entre sidebar y contenido */}
                {showDividers && dividerType === "vertical" && (
                    <Divider
                        type="vertical"
                        style={{
                            height: "auto",
                            margin: 0,
                            alignSelf: "stretch",
                            ...dividerStyle,
                        }}
                    />
                )}

                {/* Área de contenido */}
                <Layout style={{ background: "#fff", display: "flex", flexDirection: "column" }}>

                    {/* Divider horizontal superior */}
                    {showDividers && dividerType === "horizontal" && (
                        <Divider style={{ margin: 0, ...dividerStyle }} />
                    )}

                    {/* Header de sección — "Módulo › Subsección" cuando aplica */}
                    <div
                        style={{
                            background: "#f5f5f5",
                            borderBottom: "1px solid #ebebeb",
                            padding: "9px 24px",
                            paddingLeft: isMobile ? 60 : 24,
                            paddingBottom: isMobile ? 30 : 9,
                            flexShrink: 0,
                        }}
                    >
                        <Text strong style={{ fontSize: 14, color: "#444" }}>
                            {sectionTitle}
                        </Text>
                        {activeSub && (
                            <>
                                <Text style={{ margin: "0 8px", color: "#bfbfbf" }}>›</Text>
                                <Text strong style={{ fontSize: 14, color: "#00BFD6" }}>
                                    {activeSub.label || activeSub.key}
                                </Text>
                            </>
                        )}
                    </div>

                    {/* Contenido scrolleable */}
                    <Content
                        style={{
                            padding: isMobile ? "12px 12px 16px" : "16px 24px 24px",
                            overflowY: "auto",
                            flex: 1,
                            ...contentStyle,
                        }}
                    >

                        <style>{`
                            @media (min-width: 1024px) and (max-width: 1640px) {
                                .ant-form-item-label > label {
                                    white-space: normal;
                                    word-break: break-word;
                                    height: auto;
                                }
                            }
                        `}</style>

                        {showDividers && dividerType === "horizontal" && (
                            <Divider style={{ marginTop: 0, ...dividerStyle }} />
                        )}

                        {/* El segundo argumento es la subsección (null si no hay) */}
                        {typeof renderContent === "function" && selectedKey
                            ? renderContent(selectedKey, selectedSubKey)
                            : null}
                    </Content>

                    {/* Divider horizontal inferior */}
                    {showDividers && dividerType === "horizontal" && footer && (
                        <Divider style={{ margin: 0, ...dividerStyle }} />
                    )}

                    {/* Footer fijo */}
                    {footer && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                padding: "12px 10px",
                                borderTop: "1px solid #f0f0f0",
                                flexShrink: 0,
                            }}
                        >
                            {footer}
                        </div>
                    )}
                </Layout>
            </Layout>
        );
    }
}

export default SidebarMenu;
